module.exports = __webpack_public_path__ + "static/img/middle5.ae4fda4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/middle5.jpg
// module id = DF0g
// module chunks = 9